import PageHeader from "core/components/Header/PageHeader";
import { useScrollToTop } from "core/hooks/useScrollToTop";
import AppLayout from "core/layouts/AppLayout";
import BottomNavigation from "core/layouts/BottomNavigation";
import { useEffect, useState } from "react";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import CDropdownCommunity from "core/components/CDropdownCommunity";
import SelectCategoryCommunity from "../components/SelectCategoryCommunity ";
import CUser from "core/components/CUser/CUser";
import { useCustomNavigate, useRouteHistory } from "core/hooks/useCustomNavigate";
import {RouterName } from '../../../core/router';
import Comment from "../components/comment";
import CPostItem from "core/components/CPostItem/CPostItem";
import { useDetailPost } from "../hooks";
import { handleMapImagePost } from "./PersonalChannelPage";
import { CommunityTabProps } from "./CommunityListPage";
import SkeletonListCommunity from "../components/SkeletonListCommunity";
import { _t } from "core/language";

const PostDetailPage = () => {
  useScrollToTop();
  const [searchParams,] = useSearchParams();
  const navigate = useCustomNavigate();
  const { getPrevRoute } = useRouteHistory();
  const location = useLocation();
  const { id } = useParams();
  const tab = searchParams.get("tab") || "trending";
  const queryString = location?.search;
  const params = new URLSearchParams(queryString);
  const queryParams: any = {};
  const [filter, setFilter] = useState<CommunityTabProps>({ tab: tab as "trending" | "follow" | "video" });

  params.forEach((value, key) => {
    queryParams[key] = value;
  });

  const [param, setParam] = useState<any>({
    order_by: "created_at",
    order_dir: "desc",
    page: 1,
    page_size: 10,
  });
  const { dataDetail, loading } = useDetailPost(id);

  useEffect(() => {

    const viewportHeight = window.innerHeight;
    if (viewportHeight > 700) {
      setParam({ ...param, page_size: 20 })
    }
    
  }, [])

  const handleSelect = (key: string) => {
    console.log(filter,"handleSelect", key);
    setFilter({ tab: key as any });
    navigate(`${RouterName.COMMUNITY_LIST}?tab=${key}`);
  };

  const handleDropdown = (data?:any) => {
    const prevRoute = getPrevRoute();
    console.log(prevRoute,'handleDropdown', data)
    _handleGoBack()
    // navigate(-1)
  }

  const _handleClickComment = (e: any) => {
    console.log('handleClickComment', e)
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: "smooth", 
    });
    setTimeout(() => {
      document.getElementById('comment-box')?.focus();
    }, 100);
  }

  const _handleGoBack = () => {
    const prevRoute = getPrevRoute();
    if (prevRoute === RouterName.COMMUNITY_CREATE) {
      navigate(RouterName.COMMUNITY_LIST)
    } else {
      navigate(-1)
    }
  }

  return (
    <AppLayout className={` relative no-scrollbar bg-[#EEEEEE] pb-[70px]`}>
      <PageHeader
        className="fixed w-full z-[200] bg-white"
        title={_t("comunity.title")}
        handleGoBack={_handleGoBack}
      />
      <div className="px-4 pt-[43px]" />
      <div className="no-scrollbar">
        <div className={`mt-[-42px]`}>
          <SelectCategoryCommunity onSelect={handleSelect} active={tab}/>
        </div>
        <div className={`rounded-lg pt-[130px]`}>
          {!loading && <div className="pt-4  px-4 mb-2 bg-white rounded-t-lg">
            <div className="flex items-center justify-between">
              <div onClick={() => {}}>
                <CUser
                  avatar={dataDetail?.user?.avatar?.url?.thumbnail}
                  name={dataDetail?.user?.name || "@" + dataDetail?.user?.username}
                  date={dataDetail?.created_at}
                  id={dataDetail?.user_id}
                />
              </div>
              <CDropdownCommunity handleClick={handleDropdown} type="post" id={dataDetail?.id} creatorId={dataDetail?.user_id} />
            </div>
            <div className="pb-4">
              <CPostItem
                item={dataDetail}
                handleClick={() => { }}
                title={dataDetail?.content}
                thumbnail={handleMapImagePost(dataDetail)}
                likeCount={dataDetail?.total_likes}
                type="original"
                commentCount={dataDetail?.total_comments}
                shareCount={dataDetail?.total_shares}
                id={Number(id)}
                actionReactive={true}
                isGallery={dataDetail?.files?.length > 0}
                isDetail={true}
                handleClickComment={_handleClickComment}
              />
            </div>
          </div> }
          {loading && (
            <div className="grid">
              {Array.from(Array(1).keys()).map(
                (e: number) => <SkeletonListCommunity key={e} />
              )}
            </div>
          ) 
          }
          <div className="bg-white p-4">
            <Comment id={id} className="" />
          </div>

        </div>


      </div>
      <BottomNavigation activeIndex={4} />
    </AppLayout>
  );
};

export default PostDetailPage;
